import * as Stimulus from "@hotwired/stimulus"

export class InteractivityCheckController extends Stimulus.Controller {
    static get targets() {
        return [];
    }

    static values = {
        interactivity: { type: String, default: 'yes' },
        step: { type: Number }
    }

    connect() {
        DEV: this.#assertConfiguration();
    }

    startCheck(e) {
        if(this.stepValue >= 1) {
            return;
        }
        this.stepValue = this.stepValue || 1;

        setTimeout(() => {
            this.listenForAction('click');
            this.listenForAction('keydown');
            this.listenForAction('mousemove');
        }, 600);

    }

    listenForAction(eventType) {
        window.addEventListener(eventType, () => { setTimeout(() => {
            this.interactivitySatisfied(eventType);
        }, 600)}, { once: true });
    }

    interactivitySatisfied(eventType) {
        if(this.stepValue >= 2) {
            return;
        }
        this.stepValue = 2;

        var $el = document.createElement('input');
        $el.name = "_interactivity";
        $el.value = this.interactivityValue;
        $el.type = "hidden";
        this.element.append($el);
    }

    #assertConfiguration() {
        if(this.element.nodeName != 'FORM') {
            throw new Error('[InteractivityCheckController] Incorrect controller element: expected FORM but got ' + this.element.nodeName)
        }
    }

}
